import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailInput: string = control.value;

    if (!emailInput || emailInput.length === 0) {
      return null;
    }

    const email = emailInput.toLowerCase();
    const regex = new RegExp(
      // eslint-disable-next-line max-len
      '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)])'
    );

    const isValid = regex.test(email);
    let preValidate = [''];

    if (email.includes('@')) {
      const emailSplit = email.split('@');
      if (email.includes('.')) {
        preValidate = emailSplit[1].split('.', 1);
      }
    }

    return preValidate && preValidate[0].length >= 2 && isValid
      ? null
      : { invalidEmail: 'E-mail inválido' };
  };
}
